<template>
    <b-row>
        <b-col cols="12" md="6" :lg="AllowSecondLang ? 3 : 4">
            <b-form-group>
                <b-input-group :prepend="`${getTextField} Price ${number}`">
                    <b-input placeholder="Optional" class="myFeild" type="number" :name="`Food Price ${number}`" v-model="value.price"/>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="6" :lg="AllowSecondLang ? 3 : 4">
            <b-form-group>
                <b-input-group :prepend="`${getTextField} Calorie ${number}`">
                    <b-input placeholder="Optional" class="myFeild" type="number" :name="`Food Calorie ${number}`" v-model="value.calorie"/>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="6" :lg="AllowSecondLang ? 3 : 4">
            <b-form-group>
                <b-input-group :prepend="`${getTextField} Comment ${number}`">
                    <b-input placeholder="Optional" class="myFeild" type="text" :name="`Food Comment ${number}`" v-model="value.comment"/>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col v-if="AllowSecondLang" cols="12" md="6" lg="3">
            <b-form-group>
                <b-input-group :prepend="`2nd Lang Comment ${number}`">
                    <b-input placeholder="Optional" class="myFeild" type="text" :name="`2nd Lang Comment ${number}`" v-model="value.secondLangComment"/>
                </b-input-group>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "foodInfo",
        props: {
            number: {
                type: [String, Number]
            },
            value: {
                required: true,
                type: Object
            },
            AllowSecondLang: {
                type: Boolean,
                default: false
            },
            edibleType: {
                required: true,
                default: "Food",
                type: String
            }
        },
        computed: {
            getTextField () {
                return 'Item'
            }
        },
        data () {
            return {
                progressing: false
            }
        },
    }
</script>

<style scoped>

</style>
